module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'background-color': _vm.params.background
    }),
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "text-input",
    attrs: {
      "type": "text",
      "placeholder": "Say something...",
      "x-webkit-speech": ""
    },
    domProps: {
      "value": _vm.input
    },
    on: {
      "input": _vm.checkInput,
      "keyup": _vm.inputSubmit
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chat"
  }, [_c('ul', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll"
    }],
    staticClass: "chat-content"
  }, _vm._l((_vm.conversation), function(line) {
    return _c('li', {
      class: {
        'you': line.who == 'you'
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(line.text))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "show-wrapper",
    class: {
      'active': _vm.isSpeaking || _vm.isRecognizingAndReceivingInput
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.speechAnimation
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show-wrapper-text"
  }, [_vm._v(_vm._s(_vm.isRecognizing ? _vm.isRecognizingLastInput : ''))])]), _vm._v(" "), _c('div', {
    class: {
      'active': _vm.isRecognizing
    },
    attrs: {
      "id": "button"
    },
    on: {
      "click": _vm.record
    }
  }, [_c('span', {
    staticClass: "ellipse"
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "microphone",
      "data-container-transform": "translate(3)",
      "viewBox": "0 0 16 20",
      "x": "0px",
      "y": "0px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.5 0c-1.4 0-2.5 1.1-2.5 2.5v5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-5c0-1.4-1.1-2.5-2.5-2.5zm-4.125 6.188a.5.5 0 0 0-.375.5v.813c0 2.302 1.763 4.184 4 4.438v3.063h-2c-.6 0-1 .4-1 1h7c0-.6-.4-1-1-1h-2v-3.063c2.237-.254 4-2.136 4-4.438v-.813a.5.5 0 1 0-1 0v.813c0 1.927-1.573 3.5-3.5 3.5s-3.5-1.573-3.5-3.5v-.813a.5.5 0 0 0-.563-.5.5.5 0 0 0-.063 0z",
      "transform": "translate(3)"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "shadow",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "50",
      "width": "50",
      "viewBox": "0 0 744.09448819 1052.3622047"
    }
  }, [_c('ellipse', {
    staticClass: "eclipse",
    attrs: {
      "cx": "380",
      "cy": "520",
      "rx": "500",
      "ry": "500",
      "fill": "#DBDBDB",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "shadow2",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "50",
      "width": "50",
      "viewBox": "0 0 744.09448819 1052.3622047"
    }
  }, [_c('ellipse', {
    staticClass: "eclipse",
    attrs: {
      "cx": "380",
      "cy": "520",
      "rx": "500",
      "ry": "500",
      "fill": "#DBDBDB",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contents"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "visual",
    attrs: {
      "id": "viz1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visual",
    attrs: {
      "id": "viz2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visual",
    attrs: {
      "id": "viz3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visual",
    attrs: {
      "id": "viz4"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "tip"
    }
  }, [_vm._v("Press and hold to speak")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [('results' in _vm.news) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.closeNews()
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    staticClass: "modal-slick"
  }, _vm._l((_vm.news.results), function(n) {
    return _c('div', [(n.imageThumbUrl) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": n.imageThumbUrl,
        "width": "100%"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(n.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "autor"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(n.profile))]), _vm._v(" via " + _vm._s(n.sourceType))])])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container_mercedes_logo"
    }
  }, [_c('div', {
    attrs: {
      "id": "mercedes_logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-931eaecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 60
// module chunks = 1